// Global packages and components
import { clsx } from 'clsx'
import { CheckIcon } from '@heroicons/react/24/solid'

// Types
import type { ChangeEvent, HTMLAttributes, ReactNode } from 'react'

export interface CheckboxProps extends HTMLAttributes<HTMLDivElement> {
  disabled?: boolean
  checked?: boolean
  id: string
  label?: string
  children?: ReactNode
  size?: 'sm' | 'md'
  error?: string
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void
}

// Main export
const Checkbox = ({
  disabled,
  checked,
  id,
  label,
  children,
  size = 'md',
  error,
  onChange,
  className,
  ...rest
}: CheckboxProps) => (
  <div>
    <div
      {...rest}
      className={clsx('flex w-full gap-2', className)}
    >
      <input
        id={id}
        type="checkbox"
        className={clsx(
          'peer relative mr-1 shrink-0 cursor-pointer appearance-none rounded-full border-2 border-neutral-300 bg-transparent checked:border-0 checked:bg-teal-green focus:outline-none disabled:cursor-not-allowed',
          {
            'size-6': size == 'md',
            'size-5': size == 'sm',
          }
        )}
        disabled={disabled}
        checked={checked}
        onChange={onChange}
      />
      <div
        className={clsx(
          'pointer-events-none absolute hidden items-center justify-center peer-checked:flex',
          {
            'size-6': size == 'md',
            'size-5': size == 'sm',
          }
        )}
      >
        <CheckIcon className="size-4 stroke-white text-white" />
      </div>
      <label
        htmlFor={id}
        className={clsx('cursor-pointer peer-checked:font-semibold', {
          'text-sm': size == 'sm',
        })}
      >
        {children ? children : label ? label : null}
      </label>
    </div>
    {error && <p className="mb-0 pt-3 text-xs text-red-600">{error}</p>}
  </div>
)

export default Checkbox
